import React, { useState } from 'react';

import eyesIcon from 'assets/images/icons/eye.svg';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Button, FormFeedback, Input, InputGroup } from 'reactstrap';

const PasswordInput = ({ validation, name, placeholder, invalid, showPassword = false, size }) => {
  const [show, setShow] = useState(showPassword);

  const showHandler = () => {
    setShow(!show);
  };

  return (
    <InputGroup>
      <Input
        style={{
          position: 'relative',
        }}
        className={cn('auth-input', 'password-input', size)}
        name={name}
        id={name}
        value={validation.values[name] || ''}
        type={show ? 'text' : 'password'}
        placeholder={placeholder}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        invalid={invalid}
      />
      <Button
        color="secondary"
        className={cn('password-input-show-btn', size)}
        onClick={showHandler}>
        <img src={eyesIcon} />
      </Button>
      {invalid ? (
        <FormFeedback type="invalid" className="auth-input-warning-hint">
          {validation.errors[name]}
        </FormFeedback>
      ) : null}
    </InputGroup>
  );
};

export default PasswordInput;

PasswordInput.propTypes = {
  validation: PropTypes.shape({
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.any,
    touched: PropTypes.any,
    errors: PropTypes.any,
  }).isRequired,
  name: PropTypes.string.isRequired,
  showPassword: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  invalid: PropTypes.bool.isRequired,
};
